export class ApiAgentInformation {
    public agentCode: string;
    public agencyCode: string;
    public crmId: string;
    public agencyCrmId: string;
    public authId: string;
    public canInvoice: boolean;
    public companyLogoUri: string;
    public companyFaqUri: string;
    public agentName: string;
    public isDRP: boolean;

    // Partner Configuration
    public partnerWebsiteOverride: boolean;
    public phoneNumber: string;
    public emailAddress: string;
    public chatGroups: string[];
    public exactCareIconOverride: string;
    public batchPolicyTemplate: string;
    public enableCoBrand: boolean;
    public enableBhtpLogo: boolean;
    public coBrandBannerUrl: string;
    public enableWhiteLabeling: boolean;
    public termsConditions: string;
    public privacyPolicy: string;
    public securityPolicy: string;
    public disclaimer: string;
    public fraudWarning: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/api-agent-information.model.ts